import DeleteIcon from "@material-ui/icons/esm/Delete";
import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AddressDialog from 'components/AddressDialog/AddressDialog';
import { AddAddressButton, PrimaryButton, EditButton } from 'components/Button';
import Spinner from 'components/Spinner/Spinner';
import { Info } from 'components/Text';
import AddressTypes from 'constants/addressTypes';
import useCountry from 'hooks/language/useCountry';
import useAddressForm from 'utils/form/useAddressForm';
import useStyles from './AddressItemStyles';
export default function AddressItem({
  address,
  children,
  title,
  addressType,
  isLoading,
  onSave
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    getChosenCountryObjectName
  } = useCountry();
  const addressForm = useAddressForm(address);
  const {
    addressItem,
    actionButton,
    addressButton,
    addressButtons
  } = useStyles();
  const handleSubmit = async () => {
    await addressForm.handleSubmit(data => {
      onSave(addressType, data);
    })();
    setIsDialogOpen(false);
  };
  const removeAddress = () => {
    onSave(addressType, null);
  };
  if (isLoading) return /*#__PURE__*/React.createElement(Spinner, null);
  const buttonText = addressType === AddressTypes.SHIPPING ? t('profile.add_shipping_address') : t('profile.add_billing_address');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormProvider, addressForm, /*#__PURE__*/React.createElement(AddressDialog, {
    dialogTitle: title,
    open: isDialogOpen,
    onClose: () => setIsDialogOpen(false),
    isLoading: isLoading,
    primaryBtnClickIsDisabled: isLoading || !addressForm.formState.isValid,
    onPrimaryBtnClick: handleSubmit,
    primaryBtnTitle: t('buttons.save')
  })), address && /*#__PURE__*/React.createElement("div", {
    className: addressItem
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Info, null, address.addressLine1), address.addressLine2 && /*#__PURE__*/React.createElement(Info, null, address.addressLine2), address.careOfName && /*#__PURE__*/React.createElement(Info, null, address.careOfName), /*#__PURE__*/React.createElement(Info, null, address.postalCode, " ", address.postalDistrict), /*#__PURE__*/React.createElement(Info, null, address.countryCode ? getChosenCountryObjectName(address.countryCode) : '')), children, /*#__PURE__*/React.createElement("div", {
    className: addressButtons
  }, /*#__PURE__*/React.createElement("div", {
    className: addressButton
  }, addressType !== AddressTypes.CUSTOMER && /*#__PURE__*/React.createElement(PrimaryButton, {
    className: actionButton,
    onClick: removeAddress,
    startIcon: /*#__PURE__*/React.createElement(DeleteIcon, null),
    disabled: isLoading,
    loading: isLoading
  }, t('buttons.remove')), /*#__PURE__*/React.createElement(EditButton, {
    onClick: () => setIsDialogOpen(true),
    className: actionButton,
    disabled: isLoading
  }, t('buttons.edit'))))), !address && /*#__PURE__*/React.createElement(AddAddressButton, {
    onClick: () => setIsDialogOpen(true)
  }, `${buttonText} ${t('address.for_agreement')}`));
}
AddressItem.defaultProps = {
  children: null
};